var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.statistic.title))]),_c('v-card-text',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.statistic.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }